<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">{{ data.type }}</h5>
    <button
      type="button"
      class="close"
      (click)="onCancelClick()"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="filterForm" class="p-4" (ngSubmit)="onSubmit()">
    <div class="col-md-12">
      <div class="form-group">
        <label for="fromDate"
          >From Date <span class="text-danger">*</span></label
        >
        <input
          [owlDateTime]="dt1"
          [ngClass]="{
            'is-invalid':
              filterForm.get('fromDate')?.hasError('required') &&
              filterForm.get('fromDate')?.touched
          }"
          [owlDateTimeTrigger]="dt1"
          class="form-control"
          formControlName="fromDate"
          placeholder="Enter from date" />
        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
        <span class="error invalid-feedback">Please select a date</span>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <label for="toDate">To Date <span class="text-danger">*</span></label>
        <input
          [owlDateTime]="dt2"
          [ngClass]="{
            'is-invalid':
              (filterForm.get('toDate')?.hasError('required') &&
                filterForm.get('toDate')?.touched) ||
              filterForm.hasError('invalidDateRange')
          }"
          [owlDateTimeTrigger]="dt2"
          class="form-control"
          formControlName="toDate"
          placeholder="Enter to date" />
        <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
        <span
          *ngIf="!filterForm.hasError('invalidDateRange')"
          class="error invalid-feedback"
          >Please select a date</span
        >
        <span
          class="error invalid-feedback"
          *ngIf="
            filterForm.hasError('invalidDateRange') &&
            !filterForm.get('fromDate')?.errors?.['required']
          ">
          To date must be on or after From Date.
        </span>
      </div>
      <div class="col-md-12 mt-3">
        <label for="language" class="form-label"
          >Language <span class="text-danger">*</span></label
        >
        <mat-radio-group
          formControlName="language"
          aria-label="Select Language"
          color="primary"
          class="d-flex align-items-center">
          <mat-radio-button [value]="Language.English"
            >English</mat-radio-button
          >
          <mat-radio-button [value]="Language.Arabic" class="mt-2"
            >Arabic</mat-radio-button
          >
        </mat-radio-group>

        <mat-error
          *ngIf="
            filterForm.get('language')?.touched &&
            filterForm.get('language')?.hasError('required')
          ">
          Please select a language.
        </mat-error>
      </div>
      <!-- Checkbox Section (Matching Download Modal UI) -->
      <div class="my-4" style="max-width: 400px; margin: auto">
        <div class="form-check mb-3 d-flex align-items-center label-justify">
          <label for="isDeadHead">Include Dead Head</label>
          <input
            type="checkbox"
            class="form-check-input"
            id="isDeadHead"
            formControlName="isDeadHead" />
        </div>

        <div class="form-check mb-3 d-flex align-items-center label-justify">
          <label for="isFlightTime">Include Flight Time</label>
          <input
            type="checkbox"
            class="form-check-input"
            id="isFlightTime"
            formControlName="isFlightTime" />
        </div>

        <div class="form-check mb-3 d-flex align-items-center label-justify">
          <label for="isLayoverTime">Include Layover Time</label>
          <input
            type="checkbox"
            class="form-check-input"
            id="isLayoverTime"
            formControlName="isLayoverTime" />
        </div>

        <div class="form-check mb-3 d-flex align-items-center label-justify">
          <label for="isWaitingTime">Include Waiting Time</label>
          <input
            type="checkbox"
            class="form-check-input"
            id="isWaitingTime"
            formControlName="isWaitingTime" />
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <button
        [disabled]="filterForm.invalid"
        type="submit"
        class="btn btn-primary mt-3">
        Submit
      </button>
    </div>
  </form>
</div>
